import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AboutComponent = React.lazy(() => import("../Components/RootComponents/AboutComponent"));
const AboutPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AboutComponent />
      </Suspense>
    </Fragment>
  );
};

export default AboutPage;
